module.exports = __webpack_public_path__ + "static/media/start-screen-rental.5a61d822.png";